import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@pitchero/react-ui';
import TABLE_PROP_TYPES from '../../../lib/prop-types/table';

const TableFilter = ({ tables, onChange, selected }) => {
  const selectOptions = tables.map((table) => ({
    value: table.id,
    name: table.name,
    disabled: false,
  }));

  const disabled = selectOptions.length === 1;

  return (
    <Select
      options={selectOptions}
      onChange={onChange}
      disabled={disabled}
      value={selected || ''}
    />
  );
};

TableFilter.defaultProps = {
  selected: '',
};

TableFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  tables: PropTypes.arrayOf(TABLE_PROP_TYPES).isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableFilter;
